import { render, staticRenderFns } from "./PatientAppointmentNotFound.vue?vue&type=template&id=bfee3a92&scoped=true&"
import script from "./PatientAppointmentNotFound.vue?vue&type=script&lang=js&"
export * from "./PatientAppointmentNotFound.vue?vue&type=script&lang=js&"
import style0 from "./PatientAppointmentNotFound.vue?vue&type=style&index=0&id=bfee3a92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfee3a92",
  null
  
)

export default component.exports